module.exports = __webpack_public_path__ + "static/media/1024-products---5-image-3.b1227a93.png";